<script setup>
import { ref, computed } from 'vue';
import Avatar from 'next/avatar/Avatar.vue';
import Checkbox from 'dashboard/components-next/checkbox/Checkbox.vue';
import ChannelIcon from 'dashboard/components-next/icon/ChannelIcon.vue';

const props = defineProps({
  contact: { type: Object, required: true },
  selected: { type: Boolean, default: false },
  inbox: { type: Object, default: null },
  enableSelection: { type: Boolean, default: true },
  hideThumbnail: { type: Boolean, default: false },
});

const emit = defineEmits(['selectConversation']);

const hovered = ref(false);
const contactAvatarIcon = computed(() => {
  const contactName = props.contact.name?.trim() || '';
  const isPhoneNumber = /^\+?[\d\s().-]{7,}$/.test(contactName);
  return !props.contact.thumbnail && isPhoneNumber ? 'i-lucide-user' : null;
});

const onThumbnailHover = () => {
  hovered.value = !props.hideThumbnail;
};

const onThumbnailLeave = () => {
  hovered.value = false;
};

const selectedModel = computed({
  get: () => props.selected,
  set: value => {
    emit('selectConversation', value);
  },
});
</script>

<template>
  <div
    class="relative flex items-center flex-shrink-0"
    @mouseenter="onThumbnailHover"
    @mouseleave="onThumbnailLeave"
  >
    <Avatar
      v-if="!hideThumbnail"
      :name="contact.name"
      :src="contact.thumbnail"
      :size="24"
      :status="contact.availability_status"
      :icon-name="contactAvatarIcon"
      hide-offline-status
    >
      <template v-if="inbox?.id" #badge>
        <span
          class="absolute z-20 flex items-center justify-center rounded-full bg-n-solid-1 border border-n-slate-3 size-3.5 -bottom-1 -right-1"
        >
          <ChannelIcon :inbox="inbox" colored use-brand-icon class="size-3" />
        </span>
      </template>
      <template v-if="enableSelection" #overlay>
        <div
          v-if="hovered || selected"
          class="flex items-center justify-center rounded-md cursor-pointer absolute inset-0 z-10 backdrop-blur-[2px] size-6"
          @click.stop
        >
          <Checkbox v-model="selectedModel" />
        </div>
      </template>
    </Avatar>
  </div>
</template>
